import { Link } from '~/components'

interface MasteryButtonProps {
  to?: string | { pathname: string; query: Record<string, string | string[] | undefined> }
  label: string
  onClick?: () => void
}
const MasteryButton: React.FC<MasteryButtonProps> = ({ to, label, onClick }) => {
  const className =
    'bg-green-lime-soft flex justify-center items-center shadow-button-shadow px-8 rounded-large h-11 md:h-12 font-bold text-black text-sm leading-6 hover:scale-105 duration-300'
  if (to) {
    return (
      <Link className={className} onClick={onClick} to={to}>
        {label}
      </Link>
    )
  }
  return (
    <button className={className} onClick={onClick} type="button">
      {label}
    </button>
  )
}

export default MasteryButton
